"use strict";
/********************************************************************************
  HxSessionStore.ts
 
  Copyright (c) Microsoft Corporation. All rights reserved.
 ********************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxSessionStore = void 0;
var HxSessionStore = /** @class */ (function () {
    function HxSessionStore(objectStore, collectionStore, timeCollectionStore, virtualizedCollectionStore) {
        this.nextSessionId = 0;
        this.sessions = new Map();
        this.objectStore = objectStore;
        this.collectionStore = collectionStore;
        this.timeCollectionStore = timeCollectionStore;
        this.virtualizedCollectionStore = virtualizedCollectionStore;
    }
    HxSessionStore.prototype.createSession = function () {
        var id = this.nextSessionId++;
        var sessionId = id.toString();
        this.sessions.set(sessionId, {
            objectIds: new Set(),
            collectionIds: new Set(),
            timeCollectionIds: new Set(),
            virtualizedCollectionIds: new Set(),
        });
        return sessionId;
    };
    HxSessionStore.prototype.releaseSession = function (sessionId) {
        var _this = this;
        var session = this.sessions.get(sessionId);
        // Assert session
        session.objectIds.forEach(function (objectId) { return _this.releaseObjectInSession(objectId, sessionId); });
        session.collectionIds.forEach(function (collectionId) { return _this.releaseCollectionInSession(collectionId, sessionId); });
        session.timeCollectionIds.forEach(function (collectionId) { return _this.releaseTimeCollectionInSession(collectionId, sessionId); });
        session.virtualizedCollectionIds.forEach(function (collectionId) { return _this.releaseVirtualizedCollectionFromSession(collectionId, sessionId); });
        this.sessions.delete(sessionId);
    };
    // We track the reference before the object has been loaded so that we can
    // detect when an object has been dropped from active set before the load completed`
    HxSessionStore.prototype.addRefObjectInSession = function (objectCompactId, sessionId) {
        var session = this.sessions.get(sessionId);
        // Assert session !== undefined
        if (!session.objectIds.has(objectCompactId)) {
            // Since the objectStore holds one instance shared across sessions, we use ref counting
            // to know when it can drop an object.
            session.objectIds.add(objectCompactId);
            this.objectStore.addRefObject(objectCompactId, sessionId);
        }
    };
    HxSessionStore.prototype.releaseObjectInSession = function (objectCompactId, sessionId) {
        var session = this.sessions.get(sessionId);
        // Assert session !== undefined
        // Assert session has object?
        if (session.objectIds.delete(objectCompactId)) {
            this.objectStore.releaseObject(objectCompactId, sessionId);
        }
    };
    // We track the reference before the collection has been loaded so that we can
    // detect when a collection has been dropped from active set before the load completed`
    HxSessionStore.prototype.addRefCollectionInSession = function (collectionCompactId, sessionId) {
        var session = this.sessions.get(sessionId);
        // Assert session !== undefined
        if (!session.collectionIds.has(collectionCompactId)) {
            // Since the collectionStore holds one instance shared across sessions, we use ref counting
            // to know when it can drop a collection.
            session.collectionIds.add(collectionCompactId);
            this.collectionStore.addRefCollection(collectionCompactId, sessionId);
        }
    };
    HxSessionStore.prototype.releaseCollectionInSession = function (collectionCompactId, sessionId) {
        var session = this.sessions.get(sessionId);
        // Assert session !== undefined
        // Assert session has collection?
        if (session.collectionIds.delete(collectionCompactId)) {
            this.collectionStore.releaseCollection(collectionCompactId, sessionId);
        }
    };
    // We track the instance before the collection has been loaded so that we can
    // detect when a collection has been dropped from the session before the load completed`
    HxSessionStore.prototype.addTimeCollectionToSession = function (timeCollectionCompactId, sessionId) {
        var session = this.sessions.get(sessionId);
        // Assert session !== undefined
        if (!session.timeCollectionIds.has(timeCollectionCompactId)) {
            // Since the timeCollectionStore holds one instance per session we don't need ref counting
            // to know when to drop it.
            session.timeCollectionIds.add(timeCollectionCompactId);
        }
    };
    // We track the instance before the collection has been loaded so that we can
    // detect when a collection has been dropped from the session before the load completed
    HxSessionStore.prototype.addVirtualizedCollectionToSession = function (collectionCompactId, sessionId) {
        var session = this.sessions.get(sessionId);
        // Assert session !== undefined
        if (!session.virtualizedCollectionIds.has(collectionCompactId)) {
            session.virtualizedCollectionIds.add(collectionCompactId);
            this.virtualizedCollectionStore.addRefCollection(collectionCompactId, sessionId);
        }
    };
    HxSessionStore.prototype.releaseTimeCollectionInSession = function (timeCollectionCompactId, sessionId) {
        var session = this.sessions.get(sessionId);
        // Assert session !== undefined
        // Assert session has collection?
        if (session.timeCollectionIds.delete(timeCollectionCompactId)) {
            this.timeCollectionStore.releaseCollection(timeCollectionCompactId, sessionId);
        }
    };
    HxSessionStore.prototype.releaseVirtualizedCollectionFromSession = function (collectionCompactId, sessionId) {
        var session = this.sessions.get(sessionId);
        // Assert session !== undefined
        // Assert session has collection?
        if (session.virtualizedCollectionIds.delete(collectionCompactId)) {
            this.virtualizedCollectionStore.releaseCollection(collectionCompactId, sessionId);
        }
    };
    return HxSessionStore;
}());
exports.HxSessionStore = HxSessionStore;
exports.default = HxSessionStore;
